import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete, MdWhatsapp } from 'react-icons/md';
import { FiTarget } from 'react-icons/fi';
import { BsDownload } from 'react-icons/bs';
import { HiDotsVertical } from "react-icons/hi";
import { FaWpforms } from "react-icons/fa6";
import { IoSearchOutline } from 'react-icons/io5';
// Custom components
import * as React from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { IoMdAdd } from 'react-icons/io';
import CreateModal from './CreateModal';
import FileUpdate from './FileUpdate';
import DeleteModal from './DeleteModal';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { addBulkData, exportAppointmentDetail, getPatientExcelData, leadGet, searchLead, viewLead } from '../../../redux/actions/Files.action';
import Dropdown from 'react-bootstrap/Dropdown';
import { useNavigate } from 'react-router-dom';
import JsBarcode from 'jsbarcode';
import userPhoto from '../../../assets/img/user.png'
import moment from 'moment';
import { getMessage, getSetting, addCtcCalling } from '../../../redux/actions/Setting.action';
import { toast } from 'react-toastify';


import * as XLSX from "xlsx";

import { FaRegClock, FaUser } from 'react-icons/fa';
import { MdDateRange, MdLocationOn, MdComment } from 'react-icons/md';
import { FaPhone } from 'react-icons/fa6';
import { FaEye } from 'react-icons/fa';

// Add responsive styles
// const responsiveStyles = `
//   /* Styles for all screen sizes */
//   .mobile-only-button {
//     display: none !important;
//   }

//   @media only screen and (max-width: 768px) {
//     .mobile-only-button {
//       display: inline-flex !important;
//     }
//   }
// `;

// Add responsive styles
const responsiveStyles = `
  /* Styles for all screen sizes */
  .responsive-container {
    width: 100%;
  }
  
  .filter-group {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 25px;
  }
  
  .filter-item {
    flex: 1;
    min-width: 200px;
  }
  
  .filter-group input[type="date"] {
    width: 75%;
  }
  
  .search-container {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .table-responsive {
    width: 100%;
    overflow-x: auto;
  }
  
  .mobile-only-button {
    display: none !important;
  }
  
    @media only screen and (max-width: 768px) {
    .responsive-container {
      padding: 10px;
      width: 100%;
      overflow-x: auto;
    }
    
    .filter-group {
      display: flex;
      flex-direction: column;
      align-items: normal;
      gap: 15px;
      margin-bottom: 20px;
      width: 100%;
    }
    
    .filter-item {
      width: 100%;
      max-width: 300px;
      margin: 0 auto;
    }
    
    .filter-group input[type="date"] {
      width: 100% !important;
      margin:0 5px;
    }
    
    .filter-group label {
      display: block;
      margin-bottom: 8px;
    }
    
    .search-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      width: 100%;
      margin-bottom: 15px;
    }
    
    .table-responsive {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
    
    .pagination-container {
      flex-direction: column;
      align-items: center;
    }
    
    .action-buttons {
      display: flex;
      flex-wrap: wrap;
      gap: 5px;
    }
    
    .mobile-only-button {
      display: inline-flex !important;
    }
  }
`;
export default function CreateTable() {
  const [show, setShow] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [updateId, setUpdateId] = useState('');
  const [leadId, setLeadId] = useState([]);
  const [mainPage, setMainPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const dispatch = useDispatch();
  const getFile = useSelector((state) => state.files);
  const setting = useSelector((state) => state.setting);
  console.log('setting', setting);
  console.log('getFile', getFile);
  const [leadStatuses, setLeadStatuses] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const [barcodes, setBarcodes] = useState({});
  const [checked, setChecked] = useState(false);
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
    startDate: '',
    endDate: '',
    status: ''
  });

  const [isWhatsappModalOpen, setIsWhatsappModalOpen] = useState(false);
  const [whatsappInputType, setWhatsappInputType] = useState('');
  const [whatsappDropdownSelection, setWhatsappDropdownSelection] = useState('');
  const [whatsAppMessage, setWhatsAppMessage] = useState([])
  const [otherMessage, setOtherMessage] = useState('');
  const [errors, setErrors] = useState({ dropdown: '', other: '' });
  const [selectedLeadName, setSelectedLeadName] = useState('');
  const [selectedMobileNumber, setSelectedMobileNumber] = useState('');



  const handleSend = () => {
    let hasError = false;
    const newErrors = { dropdown: '', other: '' };

    if (!whatsappDropdownSelection) {
      newErrors.dropdown = 'Please select a message option.';
      hasError = true;
    }

    if (whatsappDropdownSelection === 'other' && !otherMessage.trim()) {
      newErrors.other = 'Please enter your custom message.';
      hasError = true;
    }

    setErrors(newErrors);
    if (hasError) return;

    let formattedNumber = selectedMobileNumber;
    // if (!formattedNumber.startsWith('91')) {
    //   formattedNumber = `${formattedNumber}`;
    // }

    let messageToSend = '';
    if (whatsappDropdownSelection === 'other') {
      messageToSend = otherMessage;
      setOtherMessage('');
    } else {
      const selectedMsgObj = whatsAppMessage.find((msg) => msg._id === whatsappDropdownSelection);
      messageToSend = selectedMsgObj?.description || '';
      setOtherMessage('');
    }

    const encodedMessage = encodeURIComponent(messageToSend);
    const whatsappURL = `https://api.whatsapp.com/send?phone=${formattedNumber}&text=${encodedMessage}`;

    window.open(whatsappURL, '_blank');
    closeWhatsappModal();
  };


  const openWhatsappModal = (mobileNumber, firstName, lastName) => {
    setSelectedMobileNumber(mobileNumber);
    setSelectedLeadName(`${firstName} ${lastName}`);
    setIsWhatsappModalOpen(true);
  };


  const closeWhatsappModal = () => {
    setIsWhatsappModalOpen(false);
    setWhatsappDropdownSelection('');
    setOtherMessage('');
    setErrors({ dropdown: '', other: '' });
  };
  const limits = {
    page: mainPage,
    limit: rowsPerPage
  }
  console.log("getSettings", setting?.getSetting?.leadStatuses);

  useEffect(() => {
    dispatch(getSetting())
    dispatch(getMessage())
      .then((res) => {
        if (res?.status == 200) {
          setWhatsAppMessage(res?.data?.data || []);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, [])

  useEffect(() => {
    console.log("Settings data:", setting);
    if (Array.isArray(setting?.getSetting?.getSetting?.leadStatuses) && setting?.getSetting?.getSetting?.leadStatuses?.length > 0) {
      // console.log("Lead Statuses found:", setting.getSetting.leadStatuses[0]?.leadStatuses);
      setLeadStatuses(setting?.getSetting?.getSetting?.leadStatuses || []);
    }
  }, [setting]);


  const getBackgroundColor = (leadStatusName) => {
    const status = leadStatuses.find(status =>
      status.title.toLowerCase() === leadStatusName.toLowerCase()
    );
    // console.log("+++++++++++",status);

    return status ? status.backgroundColor : "transparent";
  };

  const navigate = useNavigate();

  const handleDropdownToggle = (isOpen, id) => {
    if (isOpen) {
      setActiveDropdownId(id);
    }
  };

  const handleNavigate = (res) => {
    navigate('/master/addAppointment', { state: { showModal: true, userData: res } });
  }

  const handleCheckboxChange = (e, id) => {
    if (e.target.checked) {
      setChecked(true);
      setLeadId((prev) => {
        if (!prev.includes(id)) {
          return [...prev, id];
        }
        return prev;
      });
    } else {
      setChecked(false);
      setLeadId((prev) => prev.filter((lead) => lead !== id));
    }
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;

    setSearchDefault((prev) => {
      const updatedSearchDefault = {
        ...prev,
        [name]: value,
        page: mainPage,
        limit: rowsPerPage
      };
      const queryParams = new URLSearchParams(updatedSearchDefault).toString();
      dispatch(
        searchLead(queryParams)
      );
      return updatedSearchDefault;
    });
  };

  const handleStatusChange = (e) => {
    const { value } = e.target;
    console.log('value', value);

    setSearchDefault((prev) => {
      const updatedSearchDefault = {
        ...prev,
        status: value,
        page: mainPage,
        limit: rowsPerPage
      };
      const queryParams = new URLSearchParams(updatedSearchDefault).toString();
      dispatch(searchLead(queryParams));
      return updatedSearchDefault;
    })
  }

  const toggle = () => { setShow(!show); };

  const updateToggle = (id) => {
    setUpdateModal(!updateModal);
    dispatch(viewLead(id?._id))
    if (!updateModal) {
      setUpdateId(id);
    } else {
      setUpdateId('');
      // After closing the modal, refresh the lead list with current filters
      const updatedSearchParams = {
        ...searchDefault,
        page: mainPage,
        limit: rowsPerPage,
        search: searchQuery,
        startDate: searchDefault.startDate,
        endDate: searchDefault.endDate,
        status: searchDefault.status,
      };

      const queryParams = new URLSearchParams(updatedSearchParams).toString();
      dispatch(searchLead(queryParams));
    }
  };

  const viewToggle = () => { setViewModal(!viewModal); };

  const handleView = (id) => {
    dispatch(viewLead(id))
    navigate(`/master/viewLead/${id}`)
  }

  const deleteToggle = () => {
    setDeleteModal(!deleteModal);
  };

  const deleteData = (id) => {
    setDeleteModal(!deleteModal);
    setLeadId([id])
  }

  const handleSearch = (e) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);
    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || '',
      page: 1,
      limit: rowsPerPage,
      startDate: searchDefault.startDate,
      endDate: searchDefault.endDate,
      status: searchDefault.status,
    };
    setSearchDefault(newSearchParams);
    const queryParams = new URLSearchParams(newSearchParams).toString();
    dispatch(searchLead(queryParams));
  };

  const ChangeMainPage = (selected) => {
    const newPage = parseInt(selected.selected) + 1;
    setMainPage(newPage);

    const updatedSearchParams = {
      ...searchDefault,
      page: newPage,
      search: searchQuery,
      startDate: searchDefault.startDate,
      endDate: searchDefault.endDate,
      status: searchDefault.status,
    };

    setSearchDefault(updatedSearchParams);

    const queryParams = new URLSearchParams(updatedSearchParams).toString();
    dispatch(searchLead(queryParams));
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setMainPage(1);

    const updatedSearchParams = {
      ...searchDefault,
      page: 1,
      limit: newRowsPerPage,
    };

    setSearchDefault(updatedSearchParams);

    const queryParams = new URLSearchParams(updatedSearchParams).toString();
    dispatch(searchLead(queryParams));
  };

  const postPerPage = rowsPerPage;
  const PageCount = Math.ceil(
    getFile?.getAllLead?.data?.totalCount / postPerPage,
  );

  useEffect(() => {
    const { search, startDate, endDate, status } = searchDefault;
    const isFilterApplied = search || startDate || endDate || status;

    const updatedSearchParams = {
      ...searchDefault,
      page: 1,
    };

    const queryParams = new URLSearchParams(updatedSearchParams).toString();

    if (isFilterApplied) {
      dispatch(searchLead(queryParams));
    } else {
      dispatch(leadGet(limits));
    }
  }, [mainPage, rowsPerPage, searchDefault]);

  const handleExport = () => {
    const data = {
      search: searchDefault.search,
      startDate: searchDefault.startDate,
      endDate: searchDefault.endDate,
      status: searchDefault.status
    };
    dispatch(getPatientExcelData(data));
    setIsExporting(true); // flag to know export is triggered
  };

  useEffect(() => {
    if (
      isExporting &&
      getFile?.getPatientExcel?.data?.PatientData?.length
    ) {
      const exportData = getFile.getPatientExcel.data.PatientData.map((res) => ({
        "First Name": res.firstName || "",
        "Last Name": res.lastName || "",
        "Phone Number": res.phoneNumber || "",
        "Email": res.email || "",
        "Problem": res.problem || "",
        "Patient Code": res.patientcode || "",
      }));

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Patients");

      XLSX.writeFile(wb, "Patient_Data.xlsx");
      setIsExporting(false); // reset flag
    }
  }, [getFile?.getPatientExcel?.data?.PatientData]);

  useEffect(() => {
    const generateBarcodeImages = async () => {
      try {
        const barcodePromises = getFile?.getAllLead?.data?.PatientData?.map(async (res) => {
          if (!res?.phoneNumber) {
            console.error('No mobile number found for patient:', res);
            return null;
          }

          const canvas = document.createElement('canvas');

          // Generate barcode using mobile number
          const barcodeData = `${res.phoneNumber}`;
          JsBarcode(canvas, barcodeData, {
            format: 'CODE128', // Specify the barcode format
            width: 2,
            height: 100,
            displayValue: true,
          });

          // Convert canvas to data URL for image
          const barcodeImage = canvas.toDataURL('image/png');

          return { id: res._id, barcodeImage };
        });

        const barcodeResults = await Promise.all(barcodePromises);
        const barcodeMap = barcodeResults.reduce((acc, result) => {
          if (result) {
            acc[result.id] = result.barcodeImage;
          }
          return acc;
        }, {});

        setBarcodes(barcodeMap);
      } catch (error) {
        console.error('Error generating barcodes:', error);
      }
    };

    if (getFile?.getAllLead?.data?.PatientData) {
      generateBarcodeImages();
    }
  }, [getFile]);

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    let hours = date.getHours(); // Local hours
    const minutes = date.getMinutes(); // Local minutes
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours || 12; // convert 0 to 12
    const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;

    return `${hours}:${minutesFormatted} ${ampm}`;
  };


  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("bulkUploadFile", file);
      dispatch(addBulkData(formData, limits, searchDefault.status));
    }
  };
  // const handlePhoneClick = (phoneNumber) => {
  //   window.location.href = `tel:${phoneNumber}`;
  // };

  return (
    <>
      <style>{responsiveStyles}</style>

      <div className="responsive-container">
        <div className="mt-[100px] d-flex justify-content-between items-end mb-5 filter-group">
          <div className="d-lg-flex  gap-2 filter-group">
            <div className=''>
              <label className="text-sm">Start Date</label>
              <input
                type="date"
                name="startDate"
                value={searchDefault.startDate}
                onChange={handleDateChange}
                className="w-75 outline-none !border-b"
              />
            </div>
            <div>
              <label className="text-sm">End Date</label>
              <input
                type="date"
                name="endDate"
                value={searchDefault.endDate}
                onChange={handleDateChange}
                className="w-75 outline-none !border-b"
              />
            </div>
            <div className=''>
              <label className="text-sm block mb-1">Status</label>
              <select
                onChange={handleStatusChange}
                value={searchDefault.status}
                className='w-full border-b outline-none bg-transparent'
              >
                <option value="" disabled>
                  Select Lead Status
                </option>
                {setting?.getSetting?.getSetting?.leadStatuses?.length > 0 &&
                  setting.getSetting?.getSetting?.leadStatuses?.map((status) => (
                    <option key={status._id} value={status.title}>
                      {status.title}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="d-flex align-items-center ml-auto search-container">
            <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2">
              <IoSearchOutline />
              <input
                type="text"
                name="search"
                value={searchQuery}
                onChange={handleSearch}
                className="w-full outline-none"
                placeholder="Search..."
              />
            </div>
            <div className="me-2">
              <Button
                className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                onClick={handleExport}
              >
                <BsDownload className="mt-1 me-2" />
                Download
              </Button>
            </div>
            {
              localStorage.getItem('type') !== 'Lead' && (
                <>
                  <div className="me-2">
                    <Button
                      onClick={toggle}
                      className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                    >
                      <IoMdAdd className="mt-1 gap-1" />
                      Add Lead
                    </Button>
                  </div>
                  <div>
                    <label>
                      <input type="file" className='d-none' accept=".xlsx" onChange={handleFileUpload} />
                      <div
                        className="!bg-theme-dark text-white py-[6px] px-[12px] rounded cursor-pointer fw-bold d-flex align-item-center border-0"
                      >
                        <IoMdAdd className="mt-1 gap-1" />
                        Upload
                      </div>
                    </label>
                  </div>
                  {checked && (
                    <div className='ms-2' onClick={() => deleteToggle(leadId)}>
                      <Button
                        className="!bg-theme-dark fw-bold d-flex align-items-center border-0"
                      >
                        Delete All
                      </Button>
                    </div>
                  )}
                </>
              )
            }
          </div>
        </div>

        <div className="mt-[50px] mb-4 table-responsive">
          <div className='flex mb-4 justify-between items-center'>
            <h2 className='mb-0 fw-bold'>Lead List</h2>
            <div className='ms-auto border-r pe-3 me-3'>Total Records: <span className='text-success border-b border-success'>{getFile?.getAllLead?.data?.totalCount || 0}</span></div>
            <div>
              Rows per page:
              <select
                value={rowsPerPage}
                onChange={handleRowsPerPageChange}
                className="ms-2 border rounded-md focus:outline-none"
              >
                <option value={10}>10</option>
                <option value={30}>30</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={500}>500</option>
              </select>
            </div>
          </div>

          <TableContainer responsive="lg" className='table-container overflow-y-auto'>
            <Table variant="striped" colorScheme="blackAlpha">
              {/* <Thead>
              <Tr>
                <Th></Th>
                <Th>Date</Th>
                <Th>Branch</Th>
                <Th>First Name</Th> */}
              {/* <Th>Middle Name</Th> */}
              {/* <Th>Last Name</Th>
                <Th>Phone No.</Th>
                <Th>Lead Status</Th>
                <Th>Lead From</Th>
                <Th>Consult</Th>
                <Th>Gender</Th>
                <Th>Date Of Birth</Th>
                <Th>Country</Th>
                <Th>State</Th>
                <Th>City</Th>
                <Th>Area</Th>
                <Th>Lead Received On</Th>
                <Th>Campaign</Th>
                <Th>Campaign Detail</Th>
                <Th>Referance</Th>
                <Th>Remark</Th>
                <Th>Next Followup Date</Th>
                <Th>From</Th>
                <Th>To</Th>
                <Th>Nationality</Th>
                <Th>Dctor Name</Th>
                <Th>Counsellor assign</Th>
                <Th>Occupation</Th>
                <Th>Email</Th>
                <Th>Address</Th>
                <Th>Blood Group</Th>
                <Th>Pincode</Th>
                <Th>Photo</Th>
                <Th>Lead FollowUp Remark</Th>
                <Th>Barcode</Th>
                <Th>User</Th>
                <Th style={{ position: 'sticky', right: 80, background: '#fff', zIndex: 2, minWidth: '50px' }}>WhatsApp</Th>
                {
                  localStorage.getItem('type') !== 'Lead' && (
                    <>
                      <Th style={{ position: 'sticky', right: 0, background: '#fff', zIndex: 2, minWidth: '50px' }}>Action</Th>

                    </>
                  )
                }
              </Tr>
            </Thead>
            <Tbody>

              {
                getFile?.getAllLead?.data?.PatientData?.length > 0 ? (
                  getFile?.getAllLead?.data?.PatientData?.map((res) => {
                    return (
                      <Tr>
                        <Td>
                          <input type="checkBox" className='accent-theme-dark' checked={leadId.includes(res._id)} onChange={(e) => handleCheckboxChange(e, res._id)} />
                        </Td>
                        <Td>{res.createdAt ? moment(res.createdAt).format('DD/MM/YYYY') : ''}</Td>
                        <Td>{res.branch}</Td>
                        <Td className='capitalize'>{res.firstName}</Td> */}
              {/* <Td>{res.middleName ? `${res.middleName.charAt(0).toUpperCase()}.` : ''}</Td> */}
              {/* <Td className='capitalize'>{res.lastName}</Td>
                        <Td>{res.phoneNumber}</Td>
                        <Td className="capitalize">
                          <button
                            disabled={localStorage.getItem('type') === 'Lead'}
                            onClick={() => updateToggle(res)}
                            style={{ background: `${res.leadStatus ? `${getBackgroundColor(res.leadStatus)}` : "transparent"}`, color: `${res.leadStatus ? `white` : "black"}` }}
                            className={`cursor-pointer  px-3 py-1 rounded inline-block text-sm`}
                          >
                            {res.leadStatus}
                          </button>
                        </Td>
                        <Td>{res.leadFrom}</Td>
                        <Td>{res.problem}</Td>
                        <Td>{res.gender}</Td>
                        <Td>{res.dateOfBirth ? moment(res.dateOfBirth).format('DD/MM/YYYY') : ''}</Td>
                        <Td>{res.country}</Td>
                        <Td>{res.state}</Td>
                        <Td>{res.city}</Td>
                        <Td>{res.area}</Td>
                        <Td>{res.leadReceived}</Td>
                        <Td>{res.campaign[0]?.cname}</Td>
                        <Td>{res.campaign[0]?.description}</Td>
                        <Td>{res?.reference[0]?.doctorDetail ? `${res?.reference[0]?.doctorDetail}` : res?.reference[0]?.personDetail}</Td>
                        <Td>{res.remark}</Td>
                        <Td>{res.nextFollowUpDate ? moment(res.nextFollowUpDate).format('DD/MM/YYYY') : ''}</Td>
                        <Td>{res.from ? formatTime(res.from) : ''}</Td>
                        <Td>{res.to ? formatTime(res.to) : ''}</Td>
                        <Td>{res.nationality}</Td>
                        <Td>{res.doctorName}</Td>
                        <Td>{res.counselorAssign}</Td>
                        <Td>{res.occupation}</Td>
                        <Td>{res.email}</Td>
                        <Td>{res.address}</Td>
                        <Td>{res.bloodGroup}</Td>
                        <Td>{res.pincode}</Td> */}
              {/* <Td><img src={res.photo} alt='user photo' /></Td> */}
              {/* <Td><img src={res.photo || userPhoto} alt='user photo' width='60px' /></Td>
                        <Td>{res.leadFollowUpRemark}</Td>
                        <Td> */}
              {/* <img src={qrCodes[res._id]} alt="QR code" className="w-[60px] h-[60px]" /> */}
              {/* {barcodes[res._id] ? (
                            <img src={barcodes[res._id]} alt={`Barcode for ${res.phoneNumber}`} />
                          ) : (
                            <p>Generating barcode...</p>
                          )}
                        </Td>
                        <Td>{res.leadGeneratedByName}</Td>
                        <Td style={{
                              position: 'sticky',
                              right: 60,
                              background: '#fff',
                              zIndex: activeDropdownId === res._id ? 9 : 'auto',
                              textAlign: 'center',
                            }}>
                          <div className="d-flex gap-2 fs-6 fw-bold" onClick={() => openWhatsappModal(res.phoneNumber, res.firstName, res.lastName)}>
                            <MdWhatsapp className="text-success" size={30} />
                          </div>
                        </Td>
                        {
                          localStorage.getItem('type') !== 'Lead' && (
                            <Td style={{
                              position: 'sticky',
                              right: 0,
                              background: '#fff',
                              zIndex: activeDropdownId === res._id ? 9 : 'auto',
                            }}>

                              <>
                                <Dropdown className='action_menu' align={'start'} style={{ zIndex: 999 }} onToggle={(isOpen) => handleDropdownToggle(isOpen, res._id)} >
                                  <Dropdown.Toggle className='bg-transparent !border-none'>
                                    <HiDotsVertical className='text-dark fw-bold fs-4' />
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu className='!z-[99999]'>
                                    <Dropdown.Item onClick={() => { viewToggle(); handleView(res?._id) }} className='d-flex gap-2 fs-6 fw-bold'>
                                      < FiTarget className='text-primary' />View
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => { updateToggle(res) }} className='d-flex gap-2 fs-6 fw-bold'>
                                      <FaEdit className='text-success' />Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => deleteData(res?._id)} className='d-flex gap-2 fs-6 fw-bold'>
                                      <MdDelete className='text-danger' />Delete
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => { handleNavigate(res) }} className='d-flex gap-2 fs-6 fw-bold'>
                                      <FaWpforms className='text-warning' />Book Appoinment
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>

                              </>



                            </Td>
                          )}
                      </Tr>
                    );
                  })
                ) : (
                  <Tr>
                    <Td colSpan="35" className="text-center">No data available</Td>
                  </Tr>
                )
              }
            </Tbody> */}
              {getFile?.getAllLead?.data?.PatientData?.length > 0 ? (
                getFile?.getAllLead?.data?.PatientData?.map((res) => (
                  <div key={res._id} className="lead-card mb-4 bg-white rounded-lg shadow p-4">
                    <h3 className="text-xl font-medium mb-3 text-blue-900">
                      <FaUser className="inline-block mr-2 text-blue-900" size="18px" />
                      {res.firstName} {res.lastName}
                    </h3>

                    <TableContainer>
                      <Table variant="simple">
                        <Tbody>
                          <Tr>
                            <Td fontWeight="bold" py="1" lineHeight="short">
                              <FaWpforms className="inline-block mr-2 text-blue-500" />
                              Lead Status:&nbsp;&nbsp;
                              <button
                                disabled={localStorage.getItem('type')?.toLowerCase().trim() === 'lead'}
                                onClick={() => updateToggle(res)}
                                style={{
                                  background: res.leadStatus
                                    ? getBackgroundColor(res.leadStatus.trim().toLowerCase())
                                    : 'transparent',
                                  color: res.leadStatus ? 'white' : 'black',
                                }}
                                className="cursor-pointer px-2 py-0.5 rounded"
                              >
                                {res.leadStatus}
                              </button>
                            </Td>
                            <Td fontWeight="bold" py="1" lineHeight="short">
                              <MdDateRange className="inline-block  mr-2  text-green-500" />
                              Date:&nbsp;&nbsp;
                              <span style={{ fontWeight: "normal" }}>
                                {res.createdAt ? moment(res.createdAt).format('DD/MM/YYYY') : ''}
                              </span>
                            </Td>
                            <Td fontWeight="bold" py="1" lineHeight="short">
                              <FaRegClock className="inline-block  mr-2  text-orange-500" />
                              Time:&nbsp;&nbsp;
                              <span style={{ fontWeight: "normal" }}>
                                {res.createdAt ? formatTime(res.createdAt) : ''}
                              </span>
                            </Td>
                            <Td w="50px" py="1">
                              <div className="d-flex gap-2">
                                {/* <button
                                  className="text-primary"
                                  onClick={() => handlePhoneClick(res.phoneNumber)}
                                  title="Call"
                                >
                                  <FaPhone size={18} />
                                </button> */}
                                <button className="text-green-500 hover:text-green-700" onClick={() => openWhatsappModal(res.phoneNumber, res.firstName, res.lastName)} title="WhatsApp">
                                  <MdWhatsapp size={28} />
                                </button>
                                <button
                                  className="text-warning"
                                  onClick={() => { handleNavigate(res) }}
                                  title="Book Appointment"
                                >
                                  <FaWpforms size={24} />
                                </button>
                                <button className="text-blue-500" onClick={() => handleView(res._id)} title="View">
                                  {/* <FiTarget size={28} /> */}
                                  <FaEye size={28} />
                                </button>
                                <button className="text-success" onClick={() => updateToggle(res)} title="Edit">
                                  <FaEdit size={28} />
                                </button>
                                <button className="text-red-500" onClick={() => deleteData(res._id)} title="Delete">
                                  <MdDelete size={28} />
                                </button>
                              </div>
                            </Td>
                          </Tr>

                          <Tr sx={{ borderBottom: "none" }}>
                            <Td fontWeight="bold" py="1">
                              <FiTarget className="inline-block  mr-2  text-purple-500" />
                              Lead From:&nbsp;&nbsp;
                              <span style={{ fontWeight: "normal" }}>
                                {res.leadFrom}
                              </span>
                            </Td>
                            <Td fontWeight="bold" py="1">
                              <FaPhone className="inline-block  mr-2  text-blue-500" />
                              Phone:&nbsp;&nbsp;
                              <span style={{ fontWeight: "normal" }}>
                                {res.phoneNumber}
                              </span>
                            </Td>
                            <Td fontWeight="bold" py="1">
                              <MdLocationOn className="inline-block  mr-2  text-red-500" />
                              Location:&nbsp;&nbsp;
                              <span style={{ fontWeight: "normal" }}>
                                {res.city ? `${res.city}, ${res.country || ''}` : 'N/A'}
                              </span>
                            </Td>
                            <Td colSpan={2}></Td>
                          </Tr>

                          <Tr sx={{ borderBottom: "none" }}>
                            <Td fontWeight="bold" py="1">
                              <MdComment className="inline-block  mr-2  text-gray-500" />
                              Remark:&nbsp;&nbsp;
                              <span style={{
                                fontWeight: "normal", display: "contents",
                                maxWidth: "300px",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word"
                              }}>
                                {res.remark}
                              </span>
                            </Td>
                            {/* <Td fontWeight="bold" py="1">
                              <FaUser className="inline-block mr-2 text-green-500" />
                              Lead Assign:&nbsp;&nbsp;
                              <span style={{ fontWeight: "normal" }}>
                                {res.counselorAssignName}
                              </span>
                            </Td> */}
                          </Tr>
                          <Tr>
                            <button
                              className="py-[8px] px-[20px] rounded-full !bg-theme-dark fw-bold d-flex align-item-center border-0 text-white mt-2 ml-5"
                              onClick={async (e) => {
                                e.stopPropagation();
                                try {
                                  setIsLoading(true);
                                  await dispatch(
                                    addCtcCalling(res._id, { entityType: 'lead' }),
                                  );
                                  toast.success('CTC calling initiated');
                                } catch (error) {
                                  toast.error(
                                    error?.response?.data?.message ||
                                      'Failed to initiate CTC call',
                                  );
                                } finally {
                                  setIsLoading(false);
                                }
                              }}                              
                            >
                              <FaPhone size={12} className='mr-2 mt-1' /> Call
                            </button>
                          </Tr>


                        </Tbody>
                      </Table>
                    </TableContainer>
                  </div>
                ))
              ) : (
                <div className="text-center py-4 w-full">
                  <p className="text-gray-500 font-medium">No data found for the selected filters</p>
                  <button
                    onClick={() => {
                      setSearchDefault({
                        page: '',
                        search: '',
                        startDate: '',
                        endDate: '',
                        status: '',
                      });
                      // setFormValues({ type: '' });
                      dispatch(leadGet(limits));
                    }}
                    className="mt-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md text-sm"
                  >
                    Clear Filters
                  </button>
                </div>
              )}
            </Table>
          </TableContainer>
        </div>
      </div>

      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={ChangeMainPage}
        pageRangeDisplayed={5}
        pageCount={PageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      />

      <CreateModal show={show} toggle={toggle} limits={limits} searchDefault1={searchDefault} />

      <FileUpdate
        updateModal={updateModal}
        updateToggle={updateToggle}
        updateId={updateId}
        searchDefault1={searchDefault}
      />
      <DeleteModal deleteModal={deleteModal} deleteToggle={deleteToggle} setChecked={setChecked} leadId={leadId} limits={limits} setLeadId={setLeadId} setMainPage={setMainPage} searchDefault1={searchDefault} />


      {/* WhatsApp Modal */}
      <Modal show={isWhatsappModalOpen} onHide={closeWhatsappModal}>
        <Modal.Header closeButton>
          <Modal.Title>Send WhatsApp Message</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">Lead Name</Form.Label>
              <Form.Control
                type="text"
                readOnly
                disabled
                value={selectedLeadName}
                className="bg-light border-0 fw-bold text-dark"
                style={{ fontSize: '1.1rem' }}
              />
            </div>

            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">Mobile Number</Form.Label>
              <Form.Control
                type="text"
                readOnly
                disabled
                value={selectedMobileNumber}
                className="bg-light border-0 fw-bold text-dark"
                style={{ fontSize: '1.1rem' }}
              />
            </div>

            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">Select Message</Form.Label>
              <Form.Select
                className="border-2"
                value={whatsappDropdownSelection}
                onChange={(e) => {
                  setWhatsappDropdownSelection(e.target.value);
                  setErrors((prev) => ({ ...prev, dropdown: '' }));
                }}
              >
                <option value="">Select Option</option>
                {whatsAppMessage.map((msg) => (
                  <option key={msg._id} value={msg._id}>
                    {msg.title}
                  </option>
                ))}
                <option value="other">Other</option>
              </Form.Select>
              {errors.dropdown && (
                <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>{errors.dropdown}</div>
              )}
            </div>

            {whatsappDropdownSelection === 'other' && (
              <div className="mb-4">
                <Form.Control
                  type="text"
                  placeholder="Please specify"
                  className="border-2"
                  value={otherMessage}
                  onChange={(e) => {
                    setOtherMessage(e.target.value);
                    setErrors((prev) => ({ ...prev, other: '' }));
                  }}
                />
                {errors.other && (
                  <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>{errors.other}</div>
                )}
              </div>
            )}
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeWhatsappModal}>
            Cancel
          </Button>
          <Button
            className="!bg-theme-dark border-0 px-4"
            onClick={handleSend}
          >
            Send
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
